/*@flow*/
import type { Node } from 'react';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import useContextState from 'comps/Left2/useContextState';
import * as I from 'immutable';
import hash from 'lib/hash';

type Layer = I.Map<string, *>;

type PropsT = {
  onChange: (any[]) => any,
};

const layers2Opts = (vs) =>
  vs
    .map((v) => ({ label: v.get('name'), value: v.get('name') }))
    .sortBy((v) => v.value)
    .toJS();

const selectedInLayers = (vs: I.List<ID>, layers: I.List<Layer>) => {
  const v2 = layers.filter((v) => vs.includes(String(v.get('name'))));
  return layers2Opts(v2);
};

function useCartoLayers() {
  const s = useContextState();
  // Only load Carto layers.
  let layers = s.loadedLayers.toList().filter((v) => v.get('type') === 'cdb');
  layers = I.fromJS(s.layersLoaded.filter((v) => v.type === 'cdb'));
  return layers;
}

function useActiveLayers() {
  const s = useContextState();
  let selectedLayers = s.activeLayers;
  selectedLayers = s.layersActiveLayers.toList();
  return selectedLayers;
}

export default ({ onChange }: PropsT): Node => {
  const layers = useCartoLayers();
  const selectedLayers = useActiveLayers();
  const [selected, onSelect] = useState(selectedLayers);

  useEffect(() => {
    const values = selected.toJS();
    onChange(values);
  }, [hash(selected)]);

  return (
    <Select
      isMulti
      onChange={(v) => {
        if (!Array.isArray(v)) return;
        const values = I.List(v.map((v2) => v2.value));
        onSelect(values);
      }}
      clearable
      classNamePrefix="Select"
      value={selectedInLayers(selected, layers)}
      placeholder="Search layers"
      options={layers2Opts(layers)}
      name="layers"
      style={{ width: '100%' }}
      styles={{
        valueContainer: (v) => {
          return {
            ...v,
            padding: 0,
          };
        },
        control: (v) => {
          const borderColor = 'hsl(0, 0%, 80%)';
          return {
            ...v,
            boxShadow: 'none',
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderColor,
            borderRadius: 0,
            '&:hover': {
              borderColor,
            },
          };
        },
      }}
    />
  );
};
